<template>
  <Sheet>
    <template #leading>
      <Sheet.Button :icon="ChevronLeftIcon" @click="close()" />
    </template>
    <template #trailing>
      <Sheet.Button
        variant="primary"
        :icon="CheckmarkIcon"
        :disabled="loading"
        @click="handleSave"
      />
    </template>

    <Sheet.Body class="pt-2">
      <AddPaymentMethodBody :error-message="errorMessage" />
    </Sheet.Body>
  </Sheet>
</template>

<script setup lang="ts">
import { Sheet, useSheet } from '@dacr/library'
import { ChevronLeftIcon, CheckmarkIcon } from '@dacr/icons'

import AddPaymentMethodBody from './AddPaymentMethodBody.vue'
import { useAddPaymentMethod } from '../useAddPaymentMethod'

const { close } = useSheet()
const { loading, errorMessage, save } = useAddPaymentMethod()

const handleSave = async () => {
  if (await save()) close()
}
</script>
